//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        goIcon (e) {
            this.$emit('goIconLocation', e)
        }
    },
    props: {
        icons: {
            type: Array
        }
    }
}
